<template>
	<!--<select
	ref="input"
	v-model="model"
	class="bg-transparent">

		<option v-if="placeholder && placeholder.trim() !== ''" value="" hidden>{{ placeholder }}</option>

		<option
		v-for="item in list"
		:value="item.value">{{ item.text }}</option>

	</select>-->


	<el-select ref="input" v-model="model" :placeholder="placeholder" size="mini" :loading="loading">
		<el-option
			v-for="item in list"
			:key="item.value"
			:label="item.text"
			:value="item.value">
		</el-option>
	</el-select>
</template>

<script>

	export default {

		name: 'Select',
		props: {
			placeholder: String,
			value: [String, Number],
			active: Boolean,
			options: [Array, Function],
			getList: Function
		},
		data () {
			return {
				model: '',
				list: [],
				cached: false,
				loading: false
			}
		},
		watch: {
			model (val) {

				this.$emit('input', val)

				this.$emit('change')

			},
			active (val) {
				if (val == true) {
					if(!this.cached) {
						this.cargarLista()
					}
				} else {
					this.$refs.input.blur()
				}
			}
		},
		async created () {

			this.model = (this.value && this.value !== null) ? this.value : ""

			if (this.options) {

				if (typeof this.options === 'function') {

					this.list = [
						{
							text: 'Cargando datos',
							value: ''
						}
					]

					this.list = await this.options()

				}
				else this.list = this.options

			}
			//else this.cargarLista()

		},
		methods: {

			async cargarLista () {
				
				if (this.options) return

				this.loading = true
				const { data } = await this.getList()
				this.loading = false

				this.list = data

				this.cached = true

			},

			focus () {

				//this.$refs.input.focus()

			},
			next () {

				this.hover = this.hover + 1 > this.list.length - 1 ? 0 : this.hover + 1

			},
			back () {

				this.hover = this.hover - 1 < 0 ? this.list.length - 1 : this.hover - 1

			}
		}
	}
</script>

<style lang="css" scoped>
</style>
